module.exports = __webpack_public_path__ + "img/Recurso 22@300xt.6b27814a.webp";